import type { ReactNode } from "react";

import type { ThemeV1 } from "@/theme/schema";

type HeroRenderer = () => ReactNode;

const heroRegistry: Readonly<Record<string, HeroRenderer>> = Object.freeze({});

export function HeroSlot({ heroId }: { heroId: ThemeV1["heroId"] }) {
  const registeredId = heroId as string | null;
  if (registeredId === null) return null;
  const render = heroRegistry[registeredId];
  return render ? <section className="theme-hero">{render()}</section> : null;
}
